import React from 'react';
import CollapsibleList from 'components/CollapsibleList';

const CustomCollapsibleList = (
  list: {
    [key: string]: string;
  }[],
): JSX.Element => (
  <CollapsibleList
    items={list}
    mainItemId={list[0]?._id || '0'}
    idPropName="_id"
    valuePropName="description"
  />
);

export default CustomCollapsibleList;
